module.exports = __webpack_public_path__ + "img/partner_img6.66a1c1f1.png";